import { APPLY_GLOBAL_PERIOD, SELECTED_GLOBAL_PERIOD } from "../storageNames";

export function getDefaultPeriod() {
  const appliedToAllSelected = localStorage.getItem(APPLY_GLOBAL_PERIOD) === "true";
  const selectedGlobalPeriod = localStorage.getItem(SELECTED_GLOBAL_PERIOD);
  const parseSelectedGlobalPeriod = selectedGlobalPeriod
    ? JSON.parse(selectedGlobalPeriod)
    : null;
  if (parseSelectedGlobalPeriod) {
    parseSelectedGlobalPeriod.statePeriod.startDate = new Date(
      parseSelectedGlobalPeriod.statePeriod.startDate
    );
    parseSelectedGlobalPeriod.statePeriod.endDate = new Date(
      parseSelectedGlobalPeriod.statePeriod.endDate
    );
  }

  return { appliedToAllSelected, parseSelectedGlobalPeriod };
}
